export const URGENT_SERVICE_INFO_REQUEST_INTERVAL = 20000;

export const STARTED_URGENT_SERVICE_INFO_REQUEST_INTERVAL = 60000;
